exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clinic-pharmaceuticals .table thead th{vertical-align:bottom;font-size:15px;letter-spacing:.3px;color:var(--theme-grey);border:none;position:sticky;background-color:#fff;top:0}.clinic-pharmaceuticals .table tbody tr{transition:background-color .3s;cursor:pointer}.clinic-pharmaceuticals .table tbody tr:hover{background-color:var(--theme-shadow)}", ""]);

// exports
